import { DiscountUpdateEvent, ThemeEvents } from '@theme/events';

class MeriphoraCreatorDiscount extends HTMLElement {
  #queue = Promise.resolve();
  #registered = false;
  #controller;

  connectedCallback() {
    if (window.Shopify?.designMode || !this.dataset.code || this.#controller) return;

    this.#controller = new AbortController();
    const { signal } = this.#controller;
    document.addEventListener(ThemeEvents.cartUpdate, this.#refresh, { signal });
    document.addEventListener(ThemeEvents.discountUpdate, this.#refresh, { signal });
    window.addEventListener('pageshow', this.#onPageShow, { signal });
    this.#refresh();
  }

  disconnectedCallback() {
    this.#controller?.abort();
    this.#controller = undefined;
  }

  #onPageShow = (event) => {
    if (event.persisted) this.#refresh();
  };

  #refresh = (event) => {
    if (event?.detail?.sourceId === 'meriphora-creator-discount') return;
    if (event?.detail?.data?.didError) return;

    this.#queue = this.#queue.then(() => this.#update()).catch(() => this.#showStatus(false));
  };

  async #update() {
    if (!this.isConnected || !this.#controller) return;

    const code = this.dataset.code.trim();
    const cartUrl = this.dataset.cartUrl;
    const { signal } = this.#controller;
    const response = await fetch(`${cartUrl}.js`, { signal, cache: 'no-store' });
    if (!response.ok) throw new Error('Cart unavailable');

    let cart = await response.json();
    const codes = cart.discount_codes || [];
    const existing = codes.map((discount) => discount.code);
    const hasCode = existing.some((value) => value.toUpperCase() === code.toUpperCase());

    if (!this.#registered && !hasCode && existing.length < 5) {
      const update = await fetch(`${cartUrl}/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: [...existing, code].join(',') }),
        signal,
      });
      if (!update.ok) throw new Error('Discount unavailable');

      cart = await update.json();
      this.#registered = true;
      document.dispatchEvent(new DiscountUpdateEvent(cart, 'meriphora-creator-discount'));
    } else {
      this.#registered = true;
    }

    const applied = cart.item_count > 0 && cart.discount_codes?.some(
      (discount) => discount.code.toUpperCase() === code.toUpperCase() && discount.applicable
    );
    this.#showStatus(Boolean(applied));
  }

  #showStatus(applied) {
    const status = this.querySelector('[role="status"]');
    if (status) status.hidden = !applied;
  }
}

if (!customElements.get('meriphora-creator-discount')) {
  customElements.define('meriphora-creator-discount', MeriphoraCreatorDiscount);
}
